/** 財務アップロード行 status=error 時のエラー内容モーダル（SR-032）。 呼び出し元は行の fileName / errorInfo を渡す。閉じるのみ（確定処理なし）。 */
import React from 'react'
import { useModal, useModalExtra } from '../../../../_components/Modal'
import { useModifyClassList } from '../../../../common/utils/CSSUtils'

/**
 * @param {Object} props
 * @param {string} props.fileName
 * @param {string} props.errorText
 */
export const AccountingUploadErrorModal = ({ fileName, errorText }) => {
  const name = fileName?.trim() ? fileName : '-'
  const detail = errorText?.trim() ? errorText : '-'

  return (
    <div className="px-1">
      <div className="form-control mb-4">
        <div className="text-caption-1 mb-1 blue1--text">ファイル名</div>
        <div className="text-body break-words">{name}</div>
      </div>
      <div className="form-control">
        <div className="text-caption-1 mb-1 blue1--text">エラー内容</div>
        <div className="text-body red--text whitespace-pre-wrap break-words">{detail}</div>
      </div>
    </div>
  )
}

/**
 * 財務アップロード行の API エラー文言を閲覧用に表示する。他の確認モーダルフックと同様 `{ open… }` で揃え、呼び出し側の見通しをよくする。
 *
 * @returns {{ openAccountingUploadErrorModal: (fileName: string, errorText: string) => Promise<void> }}
 */
export const useAccountingUploadErrorModal = () => {
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()
  const { promisify } = useModifyClassList('.modal-window', ['w-[900px]'])

  const openAccountingUploadErrorModal = (fileName, errorText) => {
    return promisify((res) => {
      showModal({
        title: 'エラー内容',
        description: null,
        isCancel: false,
        isWide: false,
        isSpinnerDisabled: true,
        onClose: res,
        body: <AccountingUploadErrorModal fileName={fileName} errorText={errorText} />,
        button: [
          {
            name: '閉じる',
            className: 'footer-btn button_base',
            close: false,
            click: () => {
              _closeUpModal()
              res()
            }
          }
        ]
      })
    })
  }

  return { openAccountingUploadErrorModal }
}
